import React from "react";
import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  FormSubmitButton,
  SelectControl,
} from "../../utils/form";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { ClearButton, CustomModal, ImageUploader, Spinner, SelectKeywords } from "../common";
import { addAmcApi, updateAmcApi, getKeywordNameApi, getAmcSocialMediaNamesApi } from "./Api";
import { toast } from "react-toastify";
import { getAllSsoPartnersApi } from "../sso/Api";
import { getAdminUser, getSafeArray, isPartnerAllowed } from "../../utils/ReusableFunctions";
import { isModuleExist, MODULE_ID_MAP, publishOptions } from "../../utils/Constant";
import { withRouter } from "../../utils/hoc/withRouter";
import closeIcon from '../../assets/images/close.png';

class AmcForm extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props.editData || null;
    const AccesData = isModuleExist(MODULE_ID_MAP.ContentMasterAMC);


    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }

    let socialMedia = [];
    if (data?.socialMedia) {
      try {
        socialMedia = typeof data.socialMedia === 'string' ? JSON.parse(data.socialMedia) : data.socialMedia;
      } catch (e) {
        console.error("Failed to parse socialMedia", e);
      }
    }
    if (Array.isArray(socialMedia)) {
      socialMedia = socialMedia.map(item => {
        let mediaId = item.socialMediaId;
        if (mediaId && typeof mediaId === 'string') {
          mediaId = parseInt(mediaId, 10);
        }
        return {
          socialMediaLink: item.socialMediaLink || "",
          socialMediaId: mediaId || item.socialMedia?.id || item.id || ""
        };
      });
    } else {
      socialMedia = [];
    }

    this.state = {
      AccessData: AccesData,
      partners,
      amcName: data?.amcName || "",
      description: data?.description || "",
      thumbnailPath: "",
      thumbnailFile: null,
      bannerPath: "",
      bannerfile: null,
      circleImagePath: "",
      circleImageFile: null,
      uploadImage: data?.thumbnailPath || null,
      uploadImage2: data?.bannerPath || null,
      uploadImage3: data?.circleImagePath || null,
      resLoading: false,
      keywords: data?.keywords ? data.keywords.split(",").map(item => item.trim()).filter(Boolean) : [],
      keywordOption: [],
      search: "",
      isAddContent: true,
      socialMedia: socialMedia,
      socialMediaPlatforms: [],
    };
  }

  addSocialMediaRow = () => {
    const firstOption = this.state.socialMediaPlatforms?.[0]?.value || "";
    this.setState(prevState => ({
      socialMedia: [...prevState.socialMedia, { socialMediaLink: "", socialMediaId: firstOption }]
    }));
  };

  removeSocialMediaRow = (index) => {
    this.setState(prevState => ({
      socialMedia: prevState.socialMedia.filter((_, i) => i !== index)
    }));
  };

  componentDidMount() {
    getAllSsoPartnersApi(this);
    this.props.getKeywordNameApi(this);
    getAmcSocialMediaNamesApi(this);
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.search !== prevState.search) {
      this.props.getKeywordNameApi(this);
    }
  }
  keywordsChangeHandler = (info) => {
    this.setState({ search: info })
  }

  imageUploaser = (e, name) => {

    const imageUrl = URL.createObjectURL(e.target.files[0]);
    if (name === "banner") {
      this.setState({ bannerPath: e.target.files[0].name, bannerfile: e.target.files[0], uploadImage2: imageUrl })
    } else if (name === "circleImage") {
      this.setState({ circleImagePath: e.target.files[0].name, circleImageFile: e.target.files[0], uploadImage3: imageUrl })
    } else {
      this.setState({ thumbnailPath: e.target.files[0].name, thumbnailFile: e.target.files[0], uploadImage: imageUrl })
    }

  }

  onValidSubmit = () => {
    this.setState({ resLoading: true })
    const { thumbnailPath, bannerPath, editData, circleImagePath, amcName, description, amc, bannerfile, thumbnailFile, circleImageFile } = this.state;

    let AmcData = {
      "data": {
        ...(amcName ? { "amcName": amcName } : {}),
        ...(description ? { "description": description } : {}),
        "startDate": "2023-10-10",
        "endDate": "2023-10-19",
        ...(thumbnailPath ? { "thumbnailPath": thumbnailPath } : {}),
        ...(bannerPath ? { "bannerPath": bannerPath } : {}),
        ...(circleImagePath ? { "circleImagePath": circleImagePath } : {}),
        "keywords": this.state.keywords?.length > 0 ? this.state.keywords.join(",") : "",
        'partners': this.state.partners,
        "socialMedia": (this.state.socialMedia || []).map(item => {
          let mediaId = item.socialMediaId;
          if (mediaId && typeof mediaId === 'string') {
            mediaId = parseInt(mediaId, 10);
          }
          return {
            socialMediaLink: item.socialMediaLink || "",
            socialMediaId: mediaId ? Number(mediaId) : undefined
          };
        }),
      }
    };
    if (!isPartnerAllowed(this.state.AccessData?.id)) {
      delete AmcData.data.partners;
    }
    const data = new FormData();
    data.append("key", JSON.stringify(AmcData));
    thumbnailFile !== null && data.append("file", thumbnailFile);
    bannerfile !== null && data.append("file", bannerfile);
    circleImageFile !== null && data.append("file", circleImageFile);
    if (this.props.editData?.uuid) {
      updateAmcApi(data, this.props.ctx, this.props.onHide, this.props.editData.uuid, this)
    } else {
      addAmcApi(data, this.props.ctx, this.props.onHide, this)
    }
  }
  onHide = () => {
    this.props.getAllAmcApi();
    this.props.onHide();
  }
  render() {
    const { uploadImage, resLoading, thumbnailFile, bannerfile, uploadImage2, circleImageFile, uploadImage3 } = this.state;
    return (
      <CustomModal
        show={this.props.show}
        onHide={this.props.onHide}
        title={this.props.editData?.uuid ? "Edit AMC" : "Add AMC"}
        modalClass={"change-password"}
      >
        <Form onValidSubmit={this.onValidSubmit}>
          <Row>
            {isPartnerAllowed(this.state.AccessData?.id) &&
              <Col md={6}>
                <FormElement
                  valueLink={this.linkState(this, "partners.list")}
                  label="Publish To Partner(s)"
                  required
                  validations={[
                    {
                      validate: FormValidator.isRequired,
                      message: "Publish To cannot be empty",
                    },
                  ]}
                  control={{
                    type: SelectControl,
                    settings: {
                      options: this.state?.ssoPartnersOptions || [],
                      placeholder: "Select Partner(s)",
                      multiple: true,
                      searchable: true,
                      selectAll: true,
                      onChangeCallback: (onBlur) => {
                      },
                    },
                  }}
                />

              </Col>}
            <Col sm={6}>
              <FormElement
                valueLink={this.linkState(this, "amcName")}
                label="AMC Name"
                required
                validations={[
                  {
                    validate: FormValidator.isRequired,
                    message: "Field cannot be empty",
                  },
                ]}
                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    placeholder: "Enter AMC Name",
                  },
                }}
              />
            </Col>
            <Col sm={6}>
              <ImageUploader required={true} id="circleImage" label="Upload Logo" name={typeof (circleImageFile) == 'object' ? uploadImage3 : circleImageFile} onChange={(e) => this.imageUploaser(e, "circleImage")} onDelete={() => this.setState({ circleImageFile: "" })} />
            </Col>
            <Col sm={6}>
              <ImageUploader required={true} id="Thumbnail" label="Upload Thumbnail" name={typeof (thumbnailFile) == 'object' ? uploadImage : thumbnailFile} onChange={(e) => this.imageUploaser(e, "thumbnail")} onDelete={() => this.setState({ thumbnailFile: "" })} />
            </Col>
            <Col sm={6}>
              <ImageUploader required={false} id="Banner" label="Upload Banner" name={typeof (bannerfile) == 'object' ? uploadImage2 : bannerfile} onChange={(e) => this.imageUploaser(e, "banner")} onDelete={() => this.setState({ bannerfile: "" })} />
            </Col>
            <Col sm={12}>
              <FormElement
                valueLink={this.linkState(this, "description")}
                label="Description"
                helpText="Description can't be more than 4000 character"

                control={{
                  type: CustomTextControl,
                  settings: {
                    //   type: "",
                    as: "textarea",
                    placeholder: "Enter Description",
                  },
                }}
              />
            </Col>
            <Col sm={12} className="mt-4 mb-3">
              <h5 className="inter-semibold">Social Media Links</h5>
            </Col>
            {(this.state.socialMedia || []).map((item, index) => (
              <Col sm={12} key={index} className="mb-3">
                <Row>
                  <Col sm={5}>
                    <FormElement
                      valueLink={this.linkState(this, `socialMedia.${index}.socialMediaId`)}
                      label="Social Media Name"
                      control={{
                        type: SelectControl,
                        settings: {
                          options: this.state.socialMediaPlatforms || [],
                          placeholder: "Select Social Media",
                        },
                      }}
                    />
                  </Col>
                  <Col sm={6}>
                    <FormElement
                      valueLink={this.linkState(this, `socialMedia.${index}.socialMediaLink`)}
                      label="Channel ID"
                      required
                      validations={[
                        {
                          validate: FormValidator.isRequired,
                          message: "Channel ID cannot be empty",
                        },
                      ]}
                      control={{
                        type: CustomTextControl,
                        settings: {
                          placeholder: "Enter Channel ID",
                        },
                      }}
                    />
                  </Col>
                  <Col sm={1} className="d-flex align-items-center justify-content-start">
                    <img
                      src={closeIcon}
                      alt="Remove"
                      style={{ cursor: "pointer", width: "20px", height: "20px", marginBottom: "8px" }}
                      onClick={() => this.removeSocialMediaRow(index)}
                    />
                  </Col>
                </Row>
              </Col>
            ))}
            <Col sm={12} className="mb-4">
              <button
                type="button"
                className="primary-btn pointer cursor-pointer"
                style={{ padding: "0.5rem 1.2rem", fontSize: "1.3rem", height: "auto" }}
                onClick={this.addSocialMediaRow}
              >
                + Add Social Media Link
              </button>
            </Col>
            <Col sm={12} className="mt-4">
              <SelectKeywords
                required={false}
                label="Keywords"
                placeholder={'Enter Keywords'}
                onchangeHandler={(data) => this.keywordsChangeHandler(data)}
                selectedKeyWords={this.state.keywords}
                options={this.state.keywordOption}
                getKeys={(data) => this.setState({ keywords: data })}
              />
            </Col>
          </Row>

          <div className="submit-wrapper" style={{ justifyContent: "center" }}>
            <FormSubmitButton customClass={"primary-btn"}>
              {resLoading ? <span className="d-flex align-items-center gap-12"> <Spinner /> Saving...</span> : "Save"}
            </FormSubmitButton>
          </div>
        </Form>
      </CustomModal>
    );
  }
}

const mapStateToProps = state => ({
  // masterCategoryState: state.MasterCategoryState,
});

const mapDispatchToProps = {
  getKeywordNameApi,
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AmcForm));
